import React from 'react';
import IntroSection from '../components/IntroSection';
import RetailSolutions from '../components/RetailSolutions';
import BlueSectionDivider from '../components/BlueSectionDivider';
import RetailBenefits from '../components/RetailBenefits';
import CountriesSection from '../components/CountriesSection';
import TechStackSection from '../components/TechStackSection';
import RetailFaq from '../components/RetailFaq';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';


const Retail =()=>{
    return (
        <div>
            <IntroSection title="Retail Software Solutions" paragraph="Create a seamless shopping experience across all channels" backgroundImage="/images/retail-bg.webp"/>
            
            <RetailSolutions/>
            <BlueSectionDivider/>
            <RetailBenefits imageSrc="https://cdn.prod.website-files.com/63d3b504212f2224c6e39423/65830ca3bdbcd77576dee450_Technical%20consultancy%20fintech.png"/>
            <BlueSectionDivider/>
            <CountriesSection/>
            <BlueSectionDivider/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <RetailFaq/>
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>
        
        </div>
    )
}
export default Retail;